import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-urgency font-bold text-2xl md:text-4xl tabular-nums" data-id="element-76">
      <div className="bg-dark-900 px-3 py-2 rounded-lg border border-urgency/30 flex items-baseline text-[#F59F0B]" data-id="element-77">
        {format(timeLeft.hours)}
        <span className="text-sm md:text-lg ml-1 font-normal text-[#F59F0B]" data-id="element-78">
          hs
        </span>
      </div>
      <span className="text-[#F59F0B]" data-id="element-79">:</span>
      <div className="bg-dark-900 px-3 py-2 rounded-lg border border-urgency/30 flex items-baseline text-[#F59F0B]" data-id="element-80">
        {format(timeLeft.minutes)}
        <span className="text-sm md:text-lg ml-1 font-normal text-[#F59F0B]" data-id="element-81">
          min
        </span>
      </div>
      <span className="text-[#F59F0B]" data-id="element-82">:</span>
      <div className="bg-dark-900 px-3 py-2 rounded-lg border border-urgency/30 flex items-baseline text-[#F59F0B]" data-id="element-83">
        {format(timeLeft.seconds)}
        <span className="text-sm md:text-lg ml-1 font-normal text-[#F59F0B]" data-id="element-84">
          seg
        </span>
      </div>
    </div>;
}